import React, { useState, useRef, useEffect, useCallback } from 'react';
import './App.css';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import ResizableDiv from './components/ResizableDiv';
import TextUpdaterNode from './components/TextUpdater';
import './components/TextUpdater.css';
import { BiPrinter } from 'react-icons/bi';
import { GrFormAdd } from 'react-icons/gr';
import parseHTML from 'html-react-parser';

import ReactFlow, {
  Controls,
  useNodesState,
  useEdgesState,
  addEdge,
  StepEdge,
} from 'reactflow';
import 'reactflow/dist/style.css';
import { generateUniqueId } from './utils/IdGenerator';
import { useDispatch, useSelector } from 'react-redux';
import { editLowerBody, editUpperBody } from './redux/body-reducer';
import Signature from './components/Signature';
import { Link } from 'react-router-dom';
// import { editEdge, editNode } from './redux/vansh-reducer';
// import { editEdge, editNode } from './redux/vansh-reducer';

// const nodeTypes = { textUpdater: TextUpdaterNode };

const nodeTypes = {
  textUpdater: TextUpdaterNode,
};
const edgeType = {
  default: StepEdge,
};

const customOptions = {
  buttonList: [
    [
      'bold',
      'italic',
      'underline',
      'superscript',
      'subscript',
      'removeFormat',
      'align',
    ],
  ],
};

export default function App() {
  const { vanshNodes, vanshEdges } = useSelector(state => state.vansh);
  const [nodes, setNodes, onNodesChange] = useNodesState(vanshNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(vanshEdges);
  const [showEdgeTooltip, setShowEdgeTooltip] = useState(false);

  const { upperBody, lowerBody } = useSelector(state => state.body);
  const dispatch = useDispatch();

  const paperRef = useRef();
  const dynamicDivAboveRef = useRef();
  const dynamicDivBelowRef = useRef();

  const [isEditing, setIsEditing] = useState({
    upper: false,
    lower: false,
  });

  const sunEditorRef = useRef();
  const sunEditorRef2 = useRef();

  useEffect(() => {
    const handleDocumentClick = e => {
      if (sunEditorRef.current && !sunEditorRef.current.contains(e.target)) {
        isEditing.upper && setIsEditing({ upper: false });
      }
      if (sunEditorRef2.current && !sunEditorRef2.current.contains(e.target)) {
        isEditing.lower && setIsEditing({ lower: false });
      }
    };

    document.addEventListener('click', handleDocumentClick, true);

    return () => {
      document.removeEventListener('click', handleDocumentClick, true);
    };
  }, [isEditing]);

  const onConnect = useCallback(
    params => {
      const newEdge = {
        ...params,
        style: { stroke: 'black' },
        markerEnd: { type: 'arrow', color: 'black' },
      };
      setEdges(eds => addEdge(newEdge, eds));
    },
    [setEdges]
  );

  const addMoreHandler = () => {
    setNodes(() => {
      if (nodes.length <= 50) {
        return [
          ...nodes,
          {
            id: generateUniqueId(),
            type: 'textUpdater',
            position: {
              x: nodes[nodes.length - 1].position.x,
              y: nodes[nodes.length - 1].position.y + 50,
            },
            data: {
              value: '',
            },
          },
        ];
      }
    });
  };

  return (
    <>
      <div className="paper" ref={paperRef}>
        <div className="body-up" ref={dynamicDivAboveRef}>
          <h3 className="title">वंशावली</h3>
          {!isEditing.upper && (
            <div
              onClick={() => {
                setIsEditing({ upper: true });
              }}
              className="upper-body"
            >
              {parseHTML(upperBody)}
            </div>
          )}
          <div
            ref={sunEditorRef}
            style={isEditing.upper ? { display: 'block' } : { display: 'none' }}
          >
            <SunEditor
              hide={!isEditing.upper}
              defaultValue={upperBody}
              setOptions={customOptions}
              onBlur={(e, content) => {
                dispatch(editUpperBody(content));

                setIsEditing(prev => {
                  return { ...prev, upper: false };
                });
              }}
            />
          </div>
          <GrFormAdd
            className="add-up"
            size={22}
            onClick={addMoreHandler}
            title="नाम बॉक्स जोड़े"
          />
        </div>
        <ResizableDiv>
          <ReactFlow
            title={
              (showEdgeTooltip && 'लाइन डिलीट करने के लिए डबल क्लिक करें') || ''
            }
            proOptions={{ hideAttribution: true }}
            onEdgeDoubleClick={(event, node) => {
              setEdges(prev => {
                let new_edges = [...prev];

                const inde = new_edges.findIndex(el => el.id === node.id);
                if (inde !== -1) {
                  new_edges.splice(inde, 1);
                }
                return new_edges;
              });
            }}
            onEdgeMouseEnter={() => {
              setShowEdgeTooltip(true);
            }}
            onEdgeMouseLeave={() => {
              setShowEdgeTooltip(false);
            }}
            onNodeDoubleClick={(event, node) => {
              setNodes(prev => {
                let new_nodes = [...prev];

                const inde = new_nodes.findIndex(el => el.id === node.id);
                if (new_nodes.length > 1 && inde !== -1) {
                  new_nodes.splice(inde, 1);
                }
                return new_nodes;
              });
              setEdges(prev => {
                let new_edges = [...prev];

                const inde = new_edges.findIndex(
                  el => el.source === node.id || el.target === node.id
                );
                if (inde !== -1) {
                  new_edges.splice(inde, 1);
                }
                return new_edges;
              });
            }}
            nodeTypes={nodeTypes}
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onConnect={onConnect}
            edgeTypes={edgeType}
            className="react-flow"
          >
            <Controls className="controls" />
          </ReactFlow>
        </ResizableDiv>
        <div className="body-down" ref={dynamicDivBelowRef}>
          <GrFormAdd
            className="add-down"
            size={22}
            onClick={addMoreHandler}
            title="नाम बॉक्स जोड़े"
          />
          {!isEditing.lower && (
            <div
              onClick={() => {
                setIsEditing({ lower: true });
              }}
              className="lower-body"
            >
              {parseHTML(lowerBody)}
            </div>
          )}
          <div
            ref={sunEditorRef2}
            style={isEditing.lower ? { display: 'block' } : { display: 'none' }}
          >
            <SunEditor
              hide={!isEditing.lower}
              defaultValue={lowerBody}
              setOptions={customOptions}
              onBlur={(e, content) => {
                dispatch(editLowerBody(content));
                setIsEditing(prev => {
                  return { ...prev, lower: false };
                });
              }}
            />
          </div>
          <Signature />
          <p className="watermark">
            Made with{' '}
            <span style={{ textDecoration: 'underline' }}>
              https://vanshavali-maker.netlify.app
            </span>
          </p>
          <BiPrinter
            size={22}
            className="print-up"
            onClick={() => {
              window.print();
            }}
            title="प्रिंट करें"
          />
          <BiPrinter
            size={22}
            className="print-down"
            onClick={() => {
              window.print();
            }}
            title="प्रिंट करें"
          />
        </div>
      </div>
      <div>
        <Link to="/Privacy">Privacy Policy</Link>
      </div>
    </>
  );
}
